module.exports = __webpack_public_path__ + "img/EXTERIOR-SWIFT-2021-3.2101f29b.jpg";